import { UpdateCartArg } from '../../model/update-cart.model';
import { Observable } from 'rxjs';

export abstract class UpdateCartAdapter {
  abstract updateCart(
  data: UpdateCartArg
  ): Observable<any>;
}
